import { ReactNode, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const ShadowRoot = ({
  children,
  mode = 'open',
}: {
  children: ReactNode;
  mode?: ShadowRootMode;
}) => {
  const hostRef = useRef<HTMLInputElement>(null);
  const [shadowRoot, setShadowRoot] = useState<ShadowRoot | null>(null);

  useEffect(() => {
    if (hostRef.current && !shadowRoot) {
      setShadowRoot(() => hostRef.current?.attachShadow({ mode }) ?? null);
    }
  }, [shadowRoot, mode]);

  return <div ref={hostRef}>{shadowRoot ? createPortal(children, shadowRoot) : null}</div>;
};

export default ShadowRoot;
